import 'chart.js';

export const charts = {
    init: function() {
        charts.extensionsCharts();
    },
    lineChart: function(ids, labels, data, color) {
        const elems = ids;
        if (ids) {
            for (let i = 0; i < ids.length; i++) {
                const ctx = document.getElementById(ids[i]);
                const chart = new Chart(ctx, {
                    type: 'line',
                    data: {
                        labels: labels[i],
                        datasets: [{
                            data: data[i],
                            fill: false,
                            borderWidth: 2,
                            borderColor: color,
                            pointRadius: 4,
                            pointBackgroundColor: color,
                            pointBorderColor: '#f4f4f6',
                            pointBorderWidth: 2,
                            lineTension: 0
                        }]
                    },
                    options: {
                        aspectRatio: 1.6,
                        scales: {
                            xAxes: [{
                                gridLines: {
                                    display: false,
                                    drawBorder: false
                                },
                                ticks: {
                                    fontFamily: 'Overpass',
                                    fontSize: 11,
                                    fontStyle: 600,
                                    fontColor: '#000000'
                                }
                            }],
                            yAxes: [{
                                gridLines: {
                                    display: false,
                                    drawBorder: false
                                },
                                ticks: {
                                    fontFamily: 'Overpass',
                                    fontSize: 11,
                                    fontStyle: 600,
                                    fontColor: '#000000'
                                }
                            }],
                        },
                        legend: {
                            display: false
                        },
                        chartArea: {
                            backgroundColor: '#f4f4f6'
                        }
                    }
                });
            }
        }
    },
    extensionsCharts: function() {
        Chart.pluginService.register({
            beforeDraw: function(chart, easing) {
                if (chart.config.options.chartArea && chart.config.options.chartArea.backgroundColor) {
                    var helpers = Chart.helpers;
                    var ctx = chart.chart.ctx;
                    var chartArea = chart.chartArea;

                    ctx.save();
                    ctx.fillStyle = chart.config.options.chartArea.backgroundColor;
                    ctx.fillRect(chartArea.left, chartArea.top, chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
                    ctx.restore();
                }
            }
        });
    }
}